/*
 * Icono "DC" para la barra lateral cerrada.
 *
 * TODO(ux-ui): sustituir por el icono oficial de IMJ cuando esté disponible.
 */
export const LogoIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="DevCore"
  >
    <rect width="28" height="28" rx="6" fill="#E8792B" />
    <text
      x="14"
      y="19"
      textAnchor="middle"
      fontFamily="Inter, Helvetica, Arial, sans-serif"
      fontSize="13"
      fontWeight="700"
      fill="#0B1F2E"
    >
      DC
    </text>
  </svg>
);
